import React, { useState } from 'react';
import ReactTable from 'react-table'
import numeral from "numeral";
import moment from "moment";

const AdminTransactionTable = props => {
    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'DESKRIPSI',
        accessor: 'name',
        minWidth: 200,
        Cell: ({row,original}) => descCell(original)
    },{
        Header: 'JUMLAH',
        maxWidth: 120,
        accessor: 'debit',
        Cell: ({row,original}) => amountCell(original)
    },{
        Header: 'STATUS',
        maxWidth: 120,
        accessor: 'status',
        Cell: ({row,original}) => statusCell(original)
    },{
        Header: 'EDIT',
        maxWidth: 200,
        accessor: 'edit',
        Cell: ({row,original}) => editCell(original)
    },{
        Header: 'WAKTU DIBUAT',
        accessor: 'createdAt',
        headerStyle: { 'whiteSpace': 'unset'},
        maxWidth: 200,
        style: { 'whiteSpace': 'unset'},
        Cell: ({row, original}) => moment(row.createdAt).format("YYYY-MM-DD HH:mm")
    }];

    const descCell = (og) => {
        return (
            <div>
                <div>{og.description}</div>
                <small>KODE TRANSAKSI: {og.referenceId.toUpperCase()}</small>
            </div>
        )
    };

    const amountCell = (og) => {
        return (
            <div>
                Rp. {numeral(og.amount).format("0,0")}
            </div>
        )
    };

    const statusCell = (og) => {
        let status;
        if (og.status === 'pending') {
            status = (
                <div className="text-warning">
                    <b>pending</b>
                </div>
            )
        } else if (og.status === 'succeeded') {
            status = (
                <div className="text-success">
                    <b>berhasil</b>
                </div>
            )
        } else if (og.status === 'failed') {
            status = (
                <div className="text-muted">
                    cancel
                </div>
            )
        }
        return (
            <div>
                {status}
            </div>
        )
    };

    const editCell = (og) => {
        let trxId = og._id;
        if (og.status === 'pending') {
            return <p>Action di dashboard</p>
        } else {
            return <p>No Action</p>
        }
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={50}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminTransactionTable;
